import { useQuery, UseQueryResult } from 'react-query';
import {
  APIGetAdminDeliverySheets,
  APIGetAdminDeliverySheetStatistics,
  APIGetAdminDeliverySheetDetail
} from '../../service/api/APIAdminDeliverySheet';
import {
  AdminDeliverySheetQuery,
  AdminDeliverySheetResponse,
  DeliverySheetStatistics,
  AdminDeliverySheetDetail
} from '../../compiler/deliverySheet.interface';
import EQueryKeys from '../../utilitie/queryKey';

/**
 * Hook สำหรับดึงรายการ Delivery Sheets พร้อมการกรอง
 */
export const useGetAdminDeliverySheets = (
  queryParams?: AdminDeliverySheetQuery
): UseQueryResult<AdminDeliverySheetResponse, Error> => {
  return useQuery(
    [EQueryKeys.GET_ADMIN_DELIVERY_SHEETS, queryParams],
    () => APIGetAdminDeliverySheets(queryParams),
    {
      keepPreviousData: true,
      staleTime: 30000, // 30 seconds
      cacheTime: 300000, // 5 minutes
      retry: 1,
      onError: (error) => {
        console.error('❌ Error fetching admin delivery sheets:', error);
      },
      onSuccess: (data) => {
        console.log('✅ Admin delivery sheets fetched successfully:', data);
      }
    }
  );
};

/**
 * Hook สำหรับดึงสถิติ Delivery Sheets
 */
export const useGetAdminDeliverySheetStatistics = (): UseQueryResult<DeliverySheetStatistics, Error> => {
  return useQuery(
    [EQueryKeys.GET_ADMIN_DELIVERY_SHEET_STATISTICS],
    APIGetAdminDeliverySheetStatistics,
    {
      staleTime: 60000, // 1 minute
      cacheTime: 300000, // 5 minutes
      retry: 1,
      onError: (error) => {
        console.error('❌ Error fetching delivery sheet statistics:', error);
      },
      onSuccess: (data) => {
        console.log('✅ Delivery sheet statistics fetched successfully:', data);
      }
    }
  );
};

/**
 * Hook สำหรับดึงรายละเอียด Delivery Sheet
 * @param uuid - UUID ของ delivery_sheet
 * @param orderUuid - UUID ของ order (optional)
 */
export const useGetAdminDeliverySheetDetail = (
  uuid?: string,
  orderUuid?: string
): UseQueryResult<AdminDeliverySheetDetail, Error> => {
  return useQuery(
    [EQueryKeys.GET_ADMIN_DELIVERY_SHEET_DETAIL, uuid, orderUuid],
    () => APIGetAdminDeliverySheetDetail(uuid!, orderUuid),
    {
      enabled: !!uuid, // Only run query if uuid is provided
      staleTime: 60000, // 1 minute
      cacheTime: 300000, // 5 minutes
      retry: 1,
      onError: (error) => {
        console.error('❌ Error fetching delivery sheet detail:', error);
      },
      onSuccess: (data) => {
        console.log('✅ Delivery sheet detail fetched successfully:', data);
      }
    }
  );
};